import { TreatmentTarget } from "../treatments/treatment_target";

export class QuestionTreatment extends TreatmentTarget {
  
  constructor() {
    super();
  }

  validate() {
    let response = {requiredMissing: false, errorMessages: []};

    this.querySelectorAll(':scope > .ct_action input').forEach((input) => { 
      input.classList.remove("error")
      if(!input.value.trim()) {
        input.classList.add("error")
        response.requiredMissing = true 
      }
    });

    this.querySelectorAll(':scope > text-treatment-flow:not(.default-flow)').forEach(function(flow, index) {
      let flow_validation = flow.validate();
      if(flow_validation.requiredMissing) {
        response.requiredMissing = true;
      }
      Array.prototype.push.apply(response.errorMessages, flow_validation.errorMessages);

      flow.closest('question-treatment').querySelectorAll(':scope > .ct_action answer-option')[index].classList.remove("error");
      if(flow_validation.requiredMissing || (flow_validation.errorMessages != null && flow_validation.errorMessages.length > 0) ) {
        flow.closest('question-treatment').querySelectorAll(':scope > .ct_action answer-option')[index].classList.add("error");
      }
    }); 

    let default_flow = this.querySelector(':scope > text-treatment-flow.default-flow');
    let default_flow_validation = default_flow.validate(true);

    if(default_flow_validation.requiredMissing) {
      response.requiredMissing = true;
    }
    Array.prototype.push.apply(response.errorMessages, default_flow_validation.errorMessages);

    default_flow.closest('question-treatment').querySelector(':scope > .ct_action answer-default').classList.remove("error");
    if(default_flow_validation.requiredMissing || (default_flow_validation.errorMessages != null && default_flow_validation.errorMessages.length > 0) ) {
      default_flow.closest('question-treatment').querySelector(':scope > .ct_action answer-default').classList.add("error");
    }

    let first_error = this.querySelector(":scope > .ct_action answer-option.error");
    if(first_error != null) {
      this.selectOption(first_error);
    }
    return response;
  }

  getData() {
    let target = [];

    this.querySelectorAll(":scope > .ct_action answer-option").forEach(function(option, index) {
      let question_child = option.getData();
      this.querySelectorAll(":scope > text-treatment-flow:not(.default-flow)")[index].getData(question_child);
      target.push(question_child);
    }.bind(this));

    let default_flow = this.querySelector(":scope > text-treatment-flow.default-flow");
    // Only save default if it is set.
    if(default_flow.hasData()) {
      let default_question_child = this.querySelector(":scope > .ct_action answer-default").getData();
      default_flow.getData(default_question_child);
      target.push(default_question_child);
    }

    let question_data = target.map(data => {
      return {
        match_type: data.exact_match ? 1 : 0,
        response_pattern: data.answer_option,
        message: {
          message_type: data.message_type,
          message_responses: data.message_responses,
          text: data.message_type == 'TEXT' || data.message_type == 'QUESTION' ? data.text : null
        }
      }
    });

    return {text: this.querySelector('.question_input').value, value: question_data, type: QuestionTreatment.getType()}
  }

  getIcon() {
    return 'fa-message-question'
  }

  isTarget() {
    return false;
  }

  static getType() {
    return "QUESTION"
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        .answer_container label {
          margin-left: 10px;
        }

        .question_input {
          margin-bottom: 20px;
        }
      </style>
      <div class="col-sm-12 ct_action question_treatment" data-action_type=QUESTION>
        <div class="panel panel-default" style="min-height: 100px;">
          <h4 style="margin: 10px 10px;">Question</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
          <div class="row">
            <div class="col-md-9">
              <label>Create Question</label>
              <input class="form-control question_input" type="text" placeholder="Question">
            </div>
            <div class="col-md-12">
              <label>Create Answer</label>
            </div>
            <div class="row col-md-12 no-gutters answer_container">
              
            </div>
          </div>
          <answer-default></answer-default>
        </div>
      </div>
      <div class="option_path">
        <div class="col-sm-12 ct_line">
          <div class="bottom_line"></div>
          <div class="ct_vertical_arrow"></div>
          <div class="option_text"><span class="answer_entry">Answer</span> matched</div>
          <div class="ct_vertical_arrow">
            <div class=arrow-down></div>
          </div>
        </div>
      </div> 
    `;
    let defaultFlow = document.createElement("text-treatment-flow");
    defaultFlow.classList.add("default-flow");
    defaultFlow.flowChanged = this.childChangeOccured;
    defaultFlow.appendChild(document.createElement("text-treatment-element"))
    this.appendChild(defaultFlow);

    super.connectedCallback();

    let optionsContainer = this.querySelector(".answer_container");
    if(this.message == null) {
      let option = document.createElement("answer-option");
      let optionFlow = document.createElement("text-treatment-flow");
      optionFlow.flowChanged = this.childChangeOccured;
      optionFlow.appendChild(document.createElement("text-treatment-element"))
      
      optionsContainer.appendChild(option);
      this.appendChild(optionFlow);
      this.selectOption(option);
    } else {
      this.querySelector('.question_input').value = this.message.text;
      this.message.message_responses.forEach(function(child, index) {
        if(child.response_pattern == null) {
          this.querySelector(":scope > text-treatment-flow.default-flow").innerHTML = "";
          this.querySelector(":scope > text-treatment-flow.default-flow").renderFlow(child.message);
        } else {
          let option = document.createElement("answer-option");
          let optionFlow = document.createElement("text-treatment-flow");
          option.target_child = child.message;
          optionFlow.renderFlow(child.message);
          
          optionsContainer.appendChild(option);
          option.querySelector('.answer_input').value = child.response_pattern;
          option.querySelector('#exact_match_switch').checked = child.match_type == 1 ? true : false;
          this.appendChild(optionFlow);
        }
      }.bind(this));
      this.selectOption(this.querySelectorAll(":scope > .question_treatment answer-option")[0]);
    }
  }

  addAnswer() {
    let optionsContainer = this.querySelector(".answer_container");

    let option = document.createElement("answer-option");
    let optionFlow = document.createElement("text-treatment-flow");
    optionFlow.flowChanged = this.childChangeOccured;
    optionFlow.appendChild(document.createElement("text-treatment-element"))
    
    optionsContainer.appendChild(option);
    this.appendChild(optionFlow);
    this.selectOption(option);
  }

  removeAnswer(option) {
    let optionsContainer = this.querySelector(".answer_container");
    this.querySelectorAll(':scope > text-treatment-flow')[Array.prototype.indexOf.call(optionsContainer.children, option)].remove();
    let selectFirstOption = !option.hidden;
    option.remove();

    if(selectFirstOption) this.selectOption(optionsContainer.children[0])
  }

  selectOption(option) {
    let optionsContainer = this.querySelector(".answer_container");
    optionsContainer.children.forEach((item, index) => {item.setSelected(false)});
    this.querySelector("answer-default").setSelected(false);
    this.querySelectorAll(':scope > text-treatment-flow').forEach((item, index) => {item.classList.add('hidden')})
    option.setSelected(true);
    if(option.tagName == "ANSWER-DEFAULT") {
      this.querySelector(".answer_entry").innerHTML = "Default answer";
      this.querySelector(':scope > text-treatment-flow.default-flow').classList.remove('hidden');
    } else {
      this.querySelector(".answer_entry").innerHTML = "Answer";
      this.querySelectorAll(':scope > text-treatment-flow:not(.default-flow)')[Array.prototype.indexOf.call(optionsContainer.children, option)].classList.remove('hidden');
    }
  }

  childChangeOccured(flow, newElement) {
    if(Array.prototype.indexOf.call(flow.children, newElement) == 0) {
      let indexOfFlow = Array.prototype.indexOf.call(this.closest('question-treatment').querySelectorAll(':scope > treatment-flow:not(.default-flow)'), flow);
      let option = this.closest('question-treatment').querySelectorAll(':scope > .question_treatment answer-option')[indexOfFlow];
      // option.querySelector("div.type i").className = `fa ${newElement.getIcon()}`
    }   
  }
}
customElements.define('question-treatment', QuestionTreatment);

class AnswerOption extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = 
      `
      <style>
        answer-option .row {
          height: 54px;
          display: flex;
          align-items: center;
        }

        .match_label {
          line-height: 30px;
        }
      </style>
      <div class="row" style="margin-bottom:5px; position:relative;">
        <div class="col-md-5">
          <input type="text" class="form-control answer_input" placeholder="Answer" value="">
        </div>
        <div class="col-md-4">
          <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="right" role="form">
            <label class="col-md-5 match_label" align="left">Wild Card</label>
            <div class="col-md-4"  align="left">
              <label class="switch">
                <input type="checkbox" class="form-control switch" id="exact_match_switch">
                <span data-cy="exact_match_switch"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-3" style="line-height:30px;">
          <a class="remove_answer"><span class="fa fa-minus"></span></a>
          <a class="add_answer"><span class="fa fa-plus"></span></a>
        </div>
        <div class="col-md-1 pull-right type">
          <i style="font-size: 30px; color: #999" class="fa " aria-hidden="true"></i>
        </div>
        <div class="ct_arrow"></div>
      </div>
      `;

    this.addEventListener('click', function(e) {
      if(this.closest("question-treatment") && e.target.tagName != "SPAN" && e.target.tagName != "A") {
        let parent = this.closest("question-treatment");
        parent.selectOption(this);
      }
    }.bind(this));

    this.querySelector(".remove_answer").addEventListener('click', function(e) {
      e.preventDefault();
      let parent = this.closest("question-treatment");
      parent.removeAnswer(this);
    }.bind(this));

    this.querySelector(".add_answer").addEventListener('click', function(e) {
      e.preventDefault();
      let parent = this.closest("question-treatment");
      parent.addAnswer();
    }.bind(this));
  }

  getDTMFInput() {
    return Number(this.querySelector(".answer_input").value);
  }

  setSelected(is_selected) {
    this.selected = is_selected
    if(is_selected) {
      this.classList.add("selected");
    }
    else {
      this.classList.remove("selected");
    }
  }

  getData() {
    return {
      answer_option: this.querySelector(".answer_input").value, 
      text: null,
      exact_match: this.querySelector('#exact_match_switch').checked ? true : false,
      message_responses: []
    };
  }
}

customElements.define('answer-option', AnswerOption)

class AnswerDefault extends HTMLElement {
  constructor() {
    super();
  }

  setSelected(is_selected) {
    this.selected = is_selected
    if(is_selected) {
      this.classList.add("selected");
    }
    else {
      this.classList.remove("selected");
    }
  }

  getData() {
    return {
      answer_option: null,
      text: null,
      message_responses: []
    };
  }

  connectedCallback() {
    this.innerHTML = `
        <style>
          
        </style>
        <div class="row no-gutters" style="margin-bottom:5px; position:relative;">
          <div class="row">
            <div class="col-md-12 title">  
              <h5>No Match Found Response</h5>
              <p>Set a default answer when no match is found.</p>
            </div>
          </div>
          <div class="ct_arrow"></div>
        </div>`

    this.addEventListener('click', function(event) {
      this.closest("question-treatment").selectOption(this);
    }.bind(this));
  }
}

customElements.define('answer-default', AnswerDefault);